// extracted by mini-css-extract-plugin
export var container = "Item-module--container--qf8tD";
export var container__text = "Item-module--container__text--Gz5-0";